import { dispatch } from '@ngxs/store';
import { AccessActions } from './access.actions';
import * as i0 from "@angular/core";
export let AccessFacade = /*#__PURE__*/(() => {
  class AccessFacade {
    constructor() {
      this.logout = dispatch(AccessActions.Logout);
      this.refreshSession = dispatch(AccessActions.RefreshSession);
      // when errors occur during logging in (e.g. connection errors) this allows to skip waiting for isReady.
      // should be set in combination to redirect to e.g. an error page.
      this.suppressIsReady = dispatch(AccessActions.SuppressIsReady);
    }
    static {
      this.ɵfac = function AccessFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessFacade)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessFacade,
        factory: AccessFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessFacade;
})();